import * as types from '../mutation-types.js';

const state = () => ({
  stageHeight: 0, //页面可视范围高度,
  enterScene: 'sideWindow', // 进入场景，万铺助手[wanpuHelper]，侧边栏[sideWindow]
  chatScene: 'singleChat', // 默认单聊，单聊[singleChat]，群聊[groupChat]
  browserEnv: process.env.NODE_ENV == '' ? 'chrome' : '', //如果要模拟真机设置为空
  storeName: '31231', // 店铺名称
  bunkDesc: '', //铺位号
  pageType:'',  //页面类型 - 保险业务
  userInfo: {},
});

const getters = {
  enterScene: state => {
    return state.enterScene;
  },
  stageHeight: state => {
    return state.stageHeight;
  },
  chatScene: state => {
    return state.chatScene;
  },
  storeName: state => {
    return state.storeName;
  },
};

const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data;
  },
  setBunkDesc(state, data){
    state.bunkDesc = data;
  },
  setPageType(state, data){
    state.pageType = data;
  },
  [types.BASE_ENTER_SCENE](state, data) {
    state.enterScene = data;
  },
  [types.BASE_STAGE_HEIGHT](state, data) {
    state.stageHeight = data;
  },
  [types.BASE_CHAT_SCENE](state, data) {
    state.chatScene = data;
  },
  [types.BASE_STORE_NAME](state, data) {
    state.storeName = data;
  },
};

const actions = {
  [types.BASE_ENTER_SCENE]({ commit }, data) {
    commit(types.BASE_ENTER_SCENE, data);
  },
  [types.BASE_STAGE_HEIGHT]({ commit }, data) {
    commit(types.BASE_STAGE_HEIGHT, data);
  },
  [types.BASE_CHAT_SCENE]({ commit }, data) {
    commit(types.BASE_CHAT_SCENE, data);
  },
  [types.BASE_STORE_NAME]({ commit }, data) {
    commit(types.BASE_STORE_NAME, data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
